import { batteryLightReachApplicationBundle } from "./battery-lightreach-bundle"
import { LightReachFinancingStatus } from "../../../ProposalSetup/financing/lightreach/LightReachFinancingStatus"
import type { BatteryFinancingStatusExperienceProps } from "../financing-status-experiences"

/**
 * LightReach (Battery Only) application status for the Battery drawer: the
 * shared LightReach status and contract over Battery's commands.
 */
export function LightReachBatteryFinancingStatus({
  proposalId,
  financing,
}: BatteryFinancingStatusExperienceProps): JSX.Element {
  return (
    <LightReachFinancingStatus
      bundle={batteryLightReachApplicationBundle}
      proposalId={proposalId}
      financing={financing}
    />
  )
}
